var downloadApp = {
	container: $('.app-download-buttons'),
	buttons: {
		android: $('.download-android'),
		ios: $('.download-ios')
	},

	showButton: function(osButton) {
		downloadApp.container.css('display', 'block');
		osButton.css('display', 'block');
	},

	getMobileOperatingSystem: function() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		console.log(userAgent);

		if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
		{
			downloadApp.showButton(downloadApp.buttons.ios);
		}
		else if( userAgent.match( /Android/i ) )
		{
			downloadApp.showButton(downloadApp.buttons.android);
		}
	},

	init: function() {
		if (downloadApp.container.length > 0) {
			downloadApp.getMobileOperatingSystem();
		}
	}
};